<div class="container mt-4">
    <div class="row">
        <div class="col mb-4">
            <h1 i18n="@@myDevices">My Devices</h1>
        </div>
    </div>
    <div class="row">
        <div>
            <div class="devices-wrapper">
                <app-device-list class="devices-outer"></app-device-list>
            </div>
        </div>
    </div>
</div>
